export const SYRINGES_ACCESS_ROLES = [
    "admin",
    "manager",
    "advanced_user",
    "apotheker",
    "pta",
];

export function hasSyringesAccess(role) {
    return SYRINGES_ACCESS_ROLES.includes(role);
}

export function hasStoredSignature(signaturePath) {
    return typeof signaturePath === "string" && signaturePath.trim().length > 0;
}

export function canSignSyringesOrders(role, signaturePath) {
    return hasSyringesAccess(role) && hasStoredSignature(signaturePath);
}
